import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../services/api';

const UnsubscribePage = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | confirm | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Validate the token exists before showing confirm button
    if (token) {
      setStatus('confirm');
    } else {
      setStatus('error');
      setMessage('Invalid unsubscribe link.');
    }
  }, [token]);

  const handleUnsubscribe = async () => {
    setStatus('loading');
    try {
      await api.post(`/unsubscribe/${token}`);
      setStatus('success');
    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong. Please try again.';
      setStatus('error');
      setMessage(msg);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-color)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '48px 40px',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        boxShadow: 'var(--shadow-md)'
      }}>
        {status === 'loading' && (
          <p style={{ color: 'var(--text-secondary)' }}>Processing...</p>
        )}

        {status === 'confirm' && (
          <>
            <h2 style={{ margin: '0 0 12px', color: 'var(--text-primary)', fontSize: '22px' }}>Unsubscribe</h2>
            <p style={{ color: 'var(--text-secondary)', margin: '0 0 32px', lineHeight: 1.6 }}>
              Click the button below to unsubscribe from future emails.
              You won't receive any more messages from us.
            </p>
            <button
              onClick={handleUnsubscribe}
              style={{
                background: 'var(--primary-color)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 32px',
                fontSize: '15px',
                fontWeight: '500',
                cursor: 'pointer',
                width: '100%'
              }}
            >
              Confirm Unsubscribe
            </button>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
            <h2 style={{ margin: '0 0 12px', color: 'var(--text-primary)', fontSize: '22px' }}>You've been unsubscribed</h2>
            <p style={{ color: 'var(--text-secondary)', margin: '0 0 12px', lineHeight: 1.6 }}>
              You've been removed from our mailing list and won't receive any further emails.
            </p>
            <p style={{ color: 'var(--text-muted)', margin: 0, fontSize: '13px', lineHeight: 1.5 }}>
              Your email address has been marked as Do Not Contact and will not be used for any future outreach.
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 style={{ margin: '0 0 12px', color: 'var(--text-primary)', fontSize: '22px' }}>Something went wrong</h2>
            <p style={{ color: 'var(--text-secondary)', margin: 0, lineHeight: 1.6 }}>
              {message || 'This unsubscribe link may have already been used or is invalid.'}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
